















































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';
import { eventBus, eventBusEvents } from '@/helpers/eventBusHelper';
import { Action } from 'vuex-class';

@Component({
    name: 'Welcome',
})
export default class Welcome extends Vue {
    @Action('user/setActiveProductGroup') protected setActiveProductGroup!: (
        productGroup: ProductGroupTypes,
    ) => void;
    @Action('user/getShoppingItemsForAllGroups')
    protected getShoppingItemsForAllGroups!: () => Promise<void>;
    @Action('search/getProductTotalItemsForAllGroups')
    protected getProductTotalItemsForAllGroups!: () => Promise<void>;
    @Action('projects/getMyProjects')
    private getMyProjects!: (
        productGroup: ProductGroupTypes,
    ) => Promise<unknown>;
    @Action('search/setProductCodeSystemList')
    protected setProductCodeSystemList!: () => void;

    protected get shoppingListCount() {
        return {
            [ProductGroupTypes.Trademark]: this.$store.getters[
                'user/trademarksShopListItems'
            ]
                ? Number(this.$store.getters['user/trademarksShopListItems'].value)
                : 0,
            [ProductGroupTypes.CustomerRelations]: this.$store.getters[
                'user/customerShopListItems'
            ]
                ? Number(this.$store.getters['user/customerShopListItems'].value)
                : 0,
            [ProductGroupTypes.Goodwill]: this.$store.getters[
                'user/goodwillShopListItems'
            ]
                ? Number(this.$store.getters['user/goodwillShopListItems'].value)
                : 0,
            [ProductGroupTypes.Technology]: this.$store.getters[
                'user/technologyShopListItems'
            ]
                ? Number(this.$store.getters['user/technologyShopListItems'].value)
                : 0,
            [ProductGroupTypes.Software]: this.$store.getters[
                'user/softwareShopListItems'
            ]
                ? Number(this.$store.getters['user/softwareShopListItems'].value)
                : 0,
        };
    }

    protected get shoppingCartCount() {
        return {
            [ProductGroupTypes.Trademark]: this.$store.getters[
                'user/trademarksShopCartItems'
            ]
                ? Number(this.$store.getters['user/trademarksShopCartItems'].value)
                : 0,
            [ProductGroupTypes.CustomerRelations]: this.$store.getters[
                'user/customerShopCartItems'
            ]
                ? Number(this.$store.getters['user/customerShopCartItems'].value)
                : 0,
            [ProductGroupTypes.Goodwill]: this.$store.getters[
                'user/goodwillShopCartItems'
            ]
                ? Number(this.$store.getters['user/goodwillShopCartItems'].value)
                : 0,
            [ProductGroupTypes.Technology]: this.$store.getters[
                'user/technologyShopCartItems'
            ]
                ? Number(this.$store.getters['user/technologyShopCartItems'].value)
                : 0,
            [ProductGroupTypes.Software]: this.$store.getters[
                'user/softwareShopCartItems'
            ]
                ? Number( this.$store.getters['user/softwareShopCartItems'].value)
                : 0,
        };
    }

    protected get productTotalItemsCount() {
        return {
            [ProductGroupTypes.Trademark]: this.$store.getters[
                'search/trademarkTotalItems'
            ]
                ? this.$store.getters['search/trademarkTotalItems']
                : 0,
            [ProductGroupTypes.CustomerRelations]: this.$store.getters[
                'search/customerTotalItems'
            ]
                ? this.$store.getters['search/customerTotalItems']
                : 0,
            [ProductGroupTypes.Goodwill]: this.$store.getters[
                'search/goodwillTotalItems'
            ]
                ? this.$store.getters['search/goodwillTotalItems']
                : 0,
            [ProductGroupTypes.Technology]: this.$store.getters[
                'search/technologyTotalItems'
            ]
                ? this.$store.getters['search/technologyTotalItems']
                : 0,
            [ProductGroupTypes.Software]: this.$store.getters[
                'search/softwareTotalItems'
            ]
                ? this.$store.getters['search/softwareTotalItems']
                : 0,
        };
    }

    protected get productGroupTypes() {
        return ProductGroupTypes;
    }

    protected async navigateTo(productGroup: ProductGroupTypes) {
        await this.toggleActiveProductGroup(productGroup);
        this.$router.push({ name: 'Search' }, () =>
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading),
        );
    }

    protected async toggleActiveProductGroup(productGroup: ProductGroupTypes) {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        await this.setActiveProductGroup(productGroup);
    }

    protected navigateToProjects() {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        this.$router.push({ name: 'MyProjects' }, () =>
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading),
        );
    }

    protected get totalProjectsAmount() {
        const totalNumber = this.$store.getters['projects/myProjectsList']
            .length;
        return `${totalNumber === 0 ? 'No' : totalNumber} ${
            totalNumber === 1 ? 'project' : 'projects'
        }`;
    }

    protected async mounted() {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        await this.getShoppingItemsForAllGroups();
        await this.getProductTotalItemsForAllGroups();
        this.getMyProjects(this.$store.getters['user/activeProductGroup']).then(
            () => {
                eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            },
        );
        await this.setProductCodeSystemList();
    }

    private resolveIsOrAre(count: number) {
        if (count === 1) {
            return 'is';
        }
        return 'are';
    }

    private resolveItemPluralOrSingular(count: number) {
        if (count === 1) {
            return 'item';
        }
        return 'items';
    }
}
